var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-chip',{staticClass:"my-chip",style:(`background:${_vm.color}`),attrs:{"dense":"","text-color":"white","label":_vm.label}})
}
var staticRenderFns = []

export { render, staticRenderFns }